import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react';
import StateSelector from './StateSelector';

interface BillConfig {
  pageTitle: string;
}

interface BillLocationPromptDialogProps {
  open: boolean;
  onClose: () => void;
  billConfig: BillConfig;
  country: string;
}

const BillLocationPromptDialog: React.FC<BillLocationPromptDialogProps> = ({ open, onClose, billConfig, country }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 2, boxShadow: 8 } }}>
    <DialogTitle sx={{ textAlign: 'center', pt: 3, position: 'relative' }}>
      <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}>
        <CloseIcon />
      </IconButton>
      <LocationOnIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
      <Typography variant="h5" component="div">
        Get State-Specific Bill Information
      </Typography>
    </DialogTitle>
    <DialogContent sx={{ textAlign: 'center', pb: 3 }}>
      <Typography variant="body1" sx={{ mb: 3 }}>
        To see the status of <strong>{billConfig.pageTitle}</strong> in your state and access state-specific bill
        content, please share your location or enter your state manually.
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
        This will help you find relevant local advocacy opportunities and track bill progress in your area.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <StateSelector showMessage={false} country={country} />
      </Box>
    </DialogContent>
  </Dialog>
);

export default BillLocationPromptDialog;
